module.exports = __webpack_public_path__ + "static/media/siddharth-coorg-trip-07.c060de8d.png";